import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useConsentManager } from '../../utils/hooks/useConsentManager'
import { initializeAnalytics as initializeAnalyticsInstance } from 'modules/analytics/analytics'
import useConfig from 'modules/config/state/use-config'
import { useGetAnalyticsSettingsQuery } from 'redux/services/analytics'

const useInitializeAnalytics = () => {
  const config = useConfig()
  const dispatch = useDispatch()

  // Query analytics settings
  const analyticsSettings = useGetAnalyticsSettingsQuery({
    campaignId: config.campaignId,
    organizationId: config.organizationId,
  })

  const { airgap } = useConsentManager()

  // State to track initialization status
  const [isInitialized, setIsInitialized] = useState(false)

  /**
   * Initialize the analytics tools if consent is given and settings are available
   */
  useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        // Ensure initialization logic runs only when required conditions are met
        if (airgap && analyticsSettings.data && !isInitialized) {
          await initializeAnalyticsInstance({
            dispatch,
            settings: analyticsSettings.data,
            campaignId: config.campaignId,
            organizationId: config.organizationId,
          })

          // Mark as initialized to avoid redundant initialization
          setIsInitialized(true)

          console.log('Analytics tools initialized successfully.')
        }
      } catch (error) {
        console.error('Failed to initialize analytics tools:', error)
      }
    }

    initializeAnalytics()
  }, [
    airgap,
    analyticsSettings.data,
    config.campaignId,
    config.organizationId,
    dispatch,
    isInitialized,
  ])
}

export default useInitializeAnalytics
